/* eslint-disable no-nested-ternary */
import { WaveVariantB } from '@tmov/design-system/icons';
import React, { useEffect, useState } from 'react';

import { LoadingContainer } from '../../../components/LoadingContainer';
import NoDataContainer from '../../../components/NoDataContainer';
import { clientesPagadores } from '../../../helpers/clientesPagadores';
import { useAuth } from '../../../security/authContext';
import CardsGrid from './CardsGrid';
import Filters from './Filters';
import useFilters from './hooks/useFilters';
import { Container } from './styles';
import TransportadoraTable from './TransportadoraTable';

export default function Transportadoras() {
  const { user } = useAuth();
  const filters = useFilters();
  const [loadingClientes, setLoadingClientes] = useState(false);
  const [clientes, setClientes] = useState(null);

  useEffect(() => {
    const getClientes = async () => {
      setLoadingClientes(true);
      const result = await clientesPagadores(user.clientes_pagadores);
      setClientes(result.map(cliente => cliente.cnpj));
      setLoadingClientes(false);
    };
    getClientes();
  }, [user.clientes_pagadores]);

  return (
    <Container>
      {clientes ? (
        <>
          <Filters filters={filters} />
          <CardsGrid clientes={clientes} />
          <TransportadoraTable clientes={clientes} filters={filters} />
        </>
      ) : loadingClientes ? (
        <LoadingContainer>
          <WaveVariantB size="60px" />
        </LoadingContainer>
      ) : (
        <NoDataContainer
          title="Não foi possível obter os dados para o Dashboard"
          description="Por favor tente novamente ou entre em contato com o suporte"
        />
      )}
    </Container>
  );
}
